import React, { useState } from "react";
import Sidebar from "../../components/customers/Sidebar";
import Navbar from "../../components/customers/Navbar";
import FloatingMenuButton from "../../components/customers/FloatingMenuButton";

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex min-h-screen">
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed lg:sticky top-0 h-screen w-56 px-1 pt-2 pb-1 flex-col bg-white shadow-lg transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 transition-transform duration-300 ease-in-out lg:flex`}
        style={{ backgroundColor: "#E0E0E0", zIndex: 9998 }}
      >
        <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col pl-2">
        {/* Navbar */}
        <div className="fixed lg:sticky top-0 z-10 pt-4 px-2 lg:px-4 w-full shadow-md lg:bg-transparent lg:shadow-none">
          <Navbar isOpen={isOpen} setIsOpen={setIsOpen} />
        </div>

        {/* Scrollable content */}
        <div className="pt-[12px] pb-4 lg:pt-[9px] lg:pb-8 px-2 lg:px-2 flex-1 overflow-y-auto mt-16 lg:mt-0">
          {children}
        </div>
      </div>

      {/* Floating Menu Button */}
      <FloatingMenuButton isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};

export default Layout;
